import { render, staticRenderFns } from "./biletdetay.vue?vue&type=template&id=88d08e0c&"
import script from "./biletdetay.vue?vue&type=script&lang=js&"
export * from "./biletdetay.vue?vue&type=script&lang=js&"
import style0 from "./biletdetay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports